<template>
   <div>
        <div class="preview__uploaded__imgs mb-6 md:mb-8 xl:px-6">
            <div class="item flex flex-column tx-center cursor-pointer" v-for="(image, index) in carGallery" :key="index" @click="removeImage(index)">
                <div class="render__img rounded-4 w-full h-full bg-center bg-cover bg-no-repeat" :style="{ 'background-image': 'url(' + image + ')' }">
                    <div class="delete">
                        &times;
                    </div>
                </div>
            </div>
            <div class="item flex flex-column tx-center" v-for="index in 10 - carGallery.length">
                <div class="render__img rounded-4 w-full h-full bg-center bg-cover bg-no-repeat">

                </div>
            </div>
        </div>
        <label class="drag__drop__file cursor-pointer tx-center flex flex-column justify-content-center align-items-center w-full rounded-4 border-1 border-dashed" for="upload_gallery"
                @dragenter="OnDragEnter"
                @dragleave="OnDragLeave"
                @dragover.prevent
                @drop="OnDrop"
                :class="{ dragging: isDragging }"
            >
            <input class="hidden" id="upload_gallery" type="file" @change="OnInputChange" multiple>
            <img width="46px" class="mb-4" src="/assets/images/pages/upload_car/icon-gallery.svg" alt="">
            <p class="tx-12 lg:tx-16 tx-grey-1">
                Agrega hasta 10 imágenes de tu auto
            </p>
            <p class="tx-14 hidden xl:block underline opacity-50 m-0">
                Arrástralas aquí
            </p>
        </label>
   </div>
</template>
<script>
export default {
    data: () => ({
        isDragging: false,
        dragCount: 0,
        carGallery:[],
        galleryFiles:[]
    }),
    props : ['currentGallery'],
    methods:{
        OnDragEnter(e){
            e.preventDefault();

            this.dragCount++;
            this.isDragging = true;
        },
        OnDragLeave(e){
            e.preventDefault();

            this.dragCount--;
            if (this.dragCount <= 0) {
                this.isDragging = false;
            }
        },
        OnInputChange(e){
            const galleryFiles = e.target.files;

            Array.from(galleryFiles).forEach(file => this.addImage(file));
        },
        OnDrop(e){
            e.preventDefault();
            e.stopPropagation();

            this.isDragging = false;

            const galleryFiles = e.dataTransfer.files;

            Array.from(galleryFiles).forEach(file => this.addImage(file));
        },
        addImage(file){
            if (!file.type.match('image.*')) {
                console.log(`${file.name} archivo no valido`);
                return;
            }

            this.galleryFiles.push(file);

            const img = new Image(),
            reader = new FileReader();

            if (this.galleryFiles.length >= 11) {
                this.galleryFiles.splice(10, 1)
            } else {
                reader.onload =  (e) => this.carGallery.push(e.target.result);
                reader.readAsDataURL(file);
            }
        },
        removeImage(index) {
            this.carGallery.splice(index, 1);
            this.galleryFiles.splice(index, 1);
        },
    },
    mounted() {
        let vm = this;
        if(this.currentGallery !== "") {
            this.currentGallery.forEach((image) => {
            fetch(image.image)
              .then(res => res.blob()) // Gets the response and returns it as a blob
              .then(blob => {
                  vm.addImage(blob);
            });
            });
        }
        this.$emit('galleryFiles', this.galleryFiles);
        this.$emit('carGallery', this.carGallery);
    }
}
</script>
